import { MutationTree } from 'vuex';
import {
  SET_COMPANY_PROFILE_DATA,
  SET_ORG_KEY, SET_MEMBERS_NETWORKS,
  SET_COMPANY_LOCATIONS,
  SET_SOCIAL_MEDIA,
    SET_MEMBERS_NETWORK,
    SET_COMPANY_ACTIVITIES,

} from './mutation-types';
import { IMembers } from '../../../models/interfaces/companyProfile/iMembers';
import { Members } from '../../../models/classes/companyProfile/members';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { ILocation } from '../../../models/interfaces/iLocation'

import State from './state';
//import { IGeneralInfoOfMember } from '../../../models/interfaces/iGeneralInfoOfMember'
import { ICompanyProfile } from '../../../models/interfaces/companyProfile/iCompanyProfile';
import { IMembersInput } from "../../../models/interfaces/companyProfile/iMembersInput";
import { IMembersInCompany } from "../../../models/interfaces/companyProfile/iMembersInCompany";
import { IMemberDataPortion } from "../../../models/interfaces/companyProfile/iMemberDataPotion";
import { IActivity } from "../../../models/interfaces/companyProfile/iActivity";
import { CompanyProfile } from "../../../models/classes/companyProfile/companyProfile";
import { IActivities } from "../../../models/interfaces/companyProfile/iActivities";
import { IActivitiesInput } from "../../../models/interfaces/companyProfile/iActivitiesInput";
import { Activities } from "../../../models/classes/companyProfile/activities";

const mutations: MutationTree<State> = {
  async [SET_COMPANY_PROFILE_DATA](state: State, data: ICompanyProfile): Promise<any> {
    const companyProfileData: any = Object.keys(data).reduce((acc, key) => {
      const _acc = acc;
      if (data[key] !== undefined)
        _acc[key] = data[key];

      return _acc;
    }, {})

        return state.profile = new CompanyProfile(companyProfileData);
  },

  [SET_ORG_KEY](state: State, orgKey: string): void {
    state.orgKey = orgKey;
  },
  
	[SET_MEMBERS_NETWORKS](state: State, data: IMembersInput): void {
		const members: IMembers = new Members({
			engaged: data.engaged.members,
			active: data.active.members,
			alumni: data.alumni.members,
			waitlisted: data.waitlisted.members,
		});

		state.profile.members = members;
	},

	[SET_MEMBERS_NETWORK](state: State, data: IMemberDataPortion): void {
		const members = state.profile.members[data.type];

		state.profile.members[data.type] = [...members, ...data.members];
	},

	[SET_COMPANY_LOCATIONS](state: State, data: ILocation[]): void {
		state.profile.locations = data;
	},

	[SET_SOCIAL_MEDIA](state: State, data: any): void {
		if (data) {
			state.profile.socialMedia = data;
		}
	},

    [SET_COMPANY_ACTIVITIES](state: State, data: IActivitiesInput): void {
        const activitiesList = state.profile.activitiesList;

        if (!activitiesList) {
            state.profile.activitiesList = new Activities();
        }

        const activities = state.profile.activitiesList.activities;

        state.profile.activitiesList.activities = [...activities, ...data.activities];
        state.profile.activitiesList.page = data.nextPage;
    },
};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/company/mutations.ts